import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUsersInclusive } from '../../reducers/users';
import { getClients, getClientFees } from '../../reducers/clients';
import Tabs from '../../components/tabs';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';
import GeneralTab from './tabs/general';
import UsersTab from './tabs/users';
import ClientConfigTab from './tabs/config';
import InvoicesTab from './tabs/invoices';
import WorkersList from '../positions/workers';

import { setImpersonateRole } from '../../reducers/identity';
import { setRoleSelectorVisibility } from '../../reducers/dialogs';

class ClientPage extends React.Component {
    constructor(props) {
        super(props);
        this.getTabs = this.getTabs.bind(this);
    }

    componentDidMount() {
        const { role, client, getUsersInclusive, getClients, getClientFees, match } = this.props;
        const loadDetails = client => {
            if (!client) return;
            getUsersInclusive({ id: client.id, type: 'client' }, undefined, ['contractor']);
            getClientFees(client.id);
        };

        if (!client) {
            getClients(role.id, 'current', clients => loadDetails(clients.find(c => c.id === match.params.id)), true);
        } else {
            loadDetails(client);
        }
    }

    getTabs() {
        const { role, client, users, setImpersonateRole, setRoleSelectorVisibility } = this.props;
        return [
            { title: <FormattedMessage {...messages.general} />, content: <GeneralTab client={client} /> },
            {
                title: <FormattedMessage {...messages.users} />,
                content: (
                    <UsersTab
                        client={client}
                        role={role}
                        setImpersonateRole={setImpersonateRole}
                        setRoleSelectorVisibility={setRoleSelectorVisibility}
                        users={users.filter(user => user.account_type !== 'contractor')}
                    />
                )
            },
            {
                title: <FormattedMessage {...messages.workers} />,
                content: <WorkersList clientRole={{ id: client.id, type: 'client' }} status="active" key="workersActive" />
            },
            {
                title: <FormattedMessage {...messages.inactive} />,
                content: <WorkersList clientRole={{ id: client.id, type: 'client' }} status="inactive" key="workersInactive" />
            },
            {
                title: <FormattedMessage {...messages.invoices} />,
                content: <InvoicesTab client={client} />
            },
            { title: <FormattedMessage {...messages.config} />, content: <ClientConfigTab client={client} /> }
        ];
    }

    render() {
        const { client, users } = this.props;
        if (!client || !users) return null;

        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <Tabs items={this.getTabs()} pageWide title={client.name} isPageTitle={true} />
                    </div>
                </div>
            </div>
        );
    }
}

ClientPage.meta = {
    hide: true,
    locations: ['/client/']
};

const mapStateToProps = (state, props) => {
    return {
        role: state.identity.role,
        admins: state.users.admins,
        users: state.users.list,
        usersRole: state.users.listRole,
        usersInclude: state.users.listInclude,
        client: state.clients.list ? state.clients.list.find(c => c.id === props.match.params.id) : undefined
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClients,
            getUsersInclusive,
            getClientFees,
            setRoleSelectorVisibility,
            setImpersonateRole
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientPage);



// WEBPACK FOOTER //
// ./src/pages/client/index.jsx